import React from 'react';

class Side extends React.Component {

    //Sideがマウント後に処理される
    componentDidMount() {
        console.log("side mount did")
        console.log("side componentDidMount'sのstep: "+ this.props.step)
        console.log("side componentDidMount'sのtotalstep: " + this.props.totalstep)
        console.log("side componentDidMount'sのsteptitle: " + this.props.steptitle)
    }

    //stateが更新されたタイミングで実行
    componentDidUpdate(prevProps, prevState, snapshot){
        console.log("side componentDidUpdate")

        console.log("side componentDidUpdate'sのstep: "+this.props.step)        
        console.log("side componentDidUpdate'sのtotalstep: "+this.props.totalstep)
        console.log("side componentDidUpdate'sのsteptitle: " + this.props.steptitle)

        //更新を行ったので、stepとnextstepの関係を元に画面を描画
        //this.changeSide()

    }

    //liタグのclassNameに指定する値を取得
    getStepStateClass(key){

        console.log("getStepStateClass() in")
        console.log(key)

        if(this.props.step == key){
            return " step-active"
        }else if(key < this.props.step){
            return " step-complete"
        }else{
            return ""
        }
    }

    render() {

        //stepの初期化
        let list = [];

        //step要素の追加
        {Object.keys(this.props.steptitle).map(key => (
            list.push(
                <li className={"step"+ this.getStepStateClass(key)} id={"step" + key}  style={{ display: "list-item"}}>
                    <div className="step_dot"></div>
                    {this.props.steptitle[key]}
                </li>)
        ))}

        return (
            <section id="menu" className="sidebar">
                <ol id="steps" className="steps">
                    {list}
                </ol>
            </section>
        );
    }
}

export default Side;